import { useState } from "react";
import TextField from "@material-ui/core/TextField";
import { Tooltip, Grid, InputAdornment } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import { ToastMessage } from "../../../global/ToastMessage";
import { useDispatch, useSelector } from "react-redux";
import { altaExtraAction } from "../../../ducks/extrasDuck";
import BackDrop from "../../../global/BackDrop";
import { FPaquetesStyle } from "./styles";
import { useFormik } from "formik";
import * as yup from "yup";
import ControlledEditor from "../../../global/ControlledEditor"
import { crearExtraPaqueteTerrestre, obtenerExtrasPaqueteTerrestre } from "../../../ducks/proveedorTerrestreDuck";
import { catCiudad } from "../../../constant/catCiudad"

const validationSchema = yup.object({
  nombre: yup.string("Ingresa un nombre").required("Nombre es requerido"),
  suplemento: yup
    .number("Ingresa un precio neto")
    .required("Precio neto es requerido"),
});

const AltaExtra = (props) => {
  const InitalValues = {
    nombre: "",
    descripcion: "",
    suplemento: 0,
  }

  const { paqueteSelect } = useSelector(store => store.proveedorTerrestre)
  const origen = { IdCiudad: catCiudad.NO_APLICA };

  const classes = FPaquetesStyle()
  const dispatch = useDispatch()
  const [open, setOpen] = useState(false)
  const [isLoad, setIsload] = useState(false)
  const [planDescripcion, setPlanDescripcion] = useState("")
  const [descripcion, setDescripcion] = useState('<p><strong>Escribe aqui tu texto</strong></p>')
  const handleClickOpen = () => {
    setOpen(true)
    LimpiarForm()
  }
  const handleClose = () => {
    setOpen(false)
    LimpiarForm()
  }
  const formik = useFormik({
    initialValues: InitalValues,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      setIsload(true);
      let payload = {
        Nombre: values.nombre,
        IdOrigen: origen.IdCiudad,
        Descripcion: descripcion,
      };
      dispatch(altaExtraAction(payload)).then((Response) => {
        switch (Response.status) {
          case 500:
            ToastMessage.fire({
              icon: "error",
              title: "Ha habido un problema de conexión con el servidor",
            });
            break
          case 400:
            ToastMessage.fire({
              icon: "warning",
              title: "<strong>Atención</strong>",
              text: "Al menos un dato no se ha enviado, favor de llenar el registro.",
            });
            break
          default:
            LimpiarForm();
            let extra = {
              idPaqueteTerrestre: paqueteSelect?.IdPaqueteProveedorTerrestre,
              idExtra: Response.data,
              suplemento: Number(values.suplemento),
              descripcion: planDescripcion,
            };
            dispatch(crearExtraPaqueteTerrestre(extra)).then((respueta) => {
              switch (respueta?.status) {
                default:
                  setOpen(false);
                  setIsload(false);
                  dispatch(obtenerExtrasPaqueteTerrestre({idPaqueteTerrestre: paqueteSelect?.IdPaqueteProveedorTerrestre}));
                  ToastMessage.fire({
                    icon: "success",
                    title: "Exito en la operacion",
                  });
                  break
              }
            })
            break
        }
      })
    },
  })
  const LimpiarForm = () => {
    formik.resetForm(InitalValues);
    setDescripcion('<p><strong>Escribe aqui tu texto</strong></p>');
  };
  const onDescripcionValue = value => {
    setDescripcion(value)
  }
  const onDescripcionPlanValue = value => {
    setPlanDescripcion(value)
  }
  return (
    <div>
      <Tooltip title="Agregar extra">
        <span>
          <Button
            variant="outlined"
            color="primary"
            onClick={handleClickOpen}
            disabled={origen.IdCiudad > 0 ? false : true}
            style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "20px" }}
          >
            <AddCircleOutlineIcon />
            Nuevo extra
          </Button>
        </span>
      </Tooltip>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
        maxWidth='md'
      >
        <form onSubmit={formik.handleSubmit}>
          <DialogTitle id="form-dialog-title">Nuevo extra</DialogTitle>
          <DialogContent>
            <DialogContentText>{origen.Nombre}</DialogContentText>
            <Grid container>
              <Grid item xs={12}>
                <TextField
                  required
                  id="input-Nombre"
                  label="Nombre"
                  type="text"
                  variant="outlined"
                  name="nombre"
                  value={formik.values.nombre}
                  onChange={formik.handleChange}
                  error={formik.touched.nombre && Boolean(formik.errors.nombre)}
                  helperText={formik.touched.nombre && formik.errors.nombre}
                  className={classes.textField}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  id="input-Suplemento"
                  label="Suplemento"
                  type="text"
                  variant="outlined"
                  name="suplemento"
                  value={formik.values.suplemento}
                  onChange={formik.handleChange}
                  error={
                    formik.touched.suplemento &&
                    Boolean(formik.errors.suplemento)
                  }
                  helperText={
                    formik.touched.suplemento && formik.errors.suplemento
                  }
                  className={classes.textField}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="start">{paqueteSelect?.Moneda?.Clave}</InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <ControlledEditor onValue={onDescripcionValue} onValuePlan={onDescripcionPlanValue} content={descripcion} height="100px" />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Cancelar
            </Button>
            <Button type="submit" color="primary">
              Agregar
            </Button>
          </DialogActions>
        </form>
      </Dialog>
      <BackDrop open={isLoad} />
    </div>
  );
};
export default AltaExtra;
